module.exports = __webpack_public_path__ + "img/background035.jpg";